<template>
  <section>
    <h2>{{ $t('login.forgot-password-sent-label') }}</h2>
    <p>{{ $t('login.forgot-password-confirmation') }}</p>
    <button type="button" class="link" @click="$router.go(-2)">
      {{ $t('login.return-button') }}
    </button>
  </section>
</template>

<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'ForgotPasswordConfirmation'
  });
</script>

<style lang="scss" scoped>
  h2 {
    text-align: center;
  }

  h2,
  p {
    margin-bottom: 16px;
  }
</style>
